import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useImperativeHandle, useState } from 'react';
import { CardElement, useStripe } from '@stripe/react-stripe-js';
import { Alert } from "antd";
import * as stripeJs from "@stripe/stripe-js";
const StripeCreditCardForm = (_props, exportedRef) => {
    const [errorMessage, setErrorMessage] = useState('');
    const [cardElement, setCardElement] = useState(null);
    const stripe = useStripe();
    useImperativeHandle(exportedRef, () => {
        const createStripePaymentMethodId = (callbackFunc) => {
            stripe.createPaymentMethod({ type: 'card', card: /* Explicitly pass the stripe component */ cardElement })
                .then(response => {
                if (response.error) {
                    setErrorMessage(response.error.message || "");
                    callbackFunc(null);
                }
                else {
                    callbackFunc(response.paymentMethod.id);
                }
            })
                .catch(error => {
                setErrorMessage(error.message);
                callbackFunc(null);
            });
        };
        return ({
            createStripePaymentMethodId
        });
    });
    const setCardRef = (element) => {
        if (element) {
            setCardElement(element);
            element.on('change', function (event) {
                if (event.error) {
                    setErrorMessage(event.error.message);
                }
                else {
                    setErrorMessage('');
                }
            });
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs("label", { children: ["Please enter your credit or debit card below", _jsx(CardElement, { onReady: setCardRef })] }), errorMessage &&
                _jsx(Alert, { type: "error", title: errorMessage, banner: true })] }));
};
export default React.forwardRef(StripeCreditCardForm);
